module.exports = __webpack_public_path__ + "img/GALLERY-BALENO-2.fdff2657.jpg";